import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { AnimalKrc } from '../../components/animalKRC/ui'; 
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const AnimalKrcPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>КРС и МРС</title>
            </Helmet>
            <AnimalKrc/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default AnimalKrcPage
